/**
 * Returns the current user with flicker prevention when the store briefly returns null
 * (e.g. tab switch): falls back to sessionStorage, which stays in sync with auth until logout.
 * After logout, storage is cleared before user is null — no stale ref from a previous account.
 */
import { useAuthStore } from '@stores/authStore';
import type { AuthUser } from '@lib/auth/types';

const USER_STATE_KEY = 'fyle-user-state';

function readUserFromStorage(): AuthUser | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(USER_STATE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
}

export function useStableUser(): AuthUser | null {
  const user = useAuthStore((s) => s.user);
  if (user) return user;
  return readUserFromStorage();
}
